const featureEnabled = (): boolean => process.env.REACT_APP_VB360_ENABLED === "true";

export const vb360Access = { featureEnabled };
